export default "__VITE_ASSET__DvgZB4Nm__"